export const Navbar = () => {
    return(
        <div className="navbar">
            <a href="/collection">home</a>
            <a href="/tags">tags</a>
        </div>
    )
}

